import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PaymentsIcon from '@mui/icons-material/Payments';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

import { WizardPriceBreakdown, WizardSummaryRow } from 'src/helpers/userCheckinWizard';

interface Props {
  summaryRows: WizardSummaryRow[];
  priceBreakdown: WizardPriceBreakdown;
}

export default function SummaryStep({ summaryRows, priceBreakdown }: Props) {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography variant="subtitle1" gutterBottom>
          {t('userCheckinWizard.summarySerialTitle')}
        </Typography>
        {!summaryRows.length ? (
          <Typography color="text.secondary">{t('userCheckinWizard.summaryEmpty')}</Typography>
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>{t('form.name')}</TableCell>
                  <TableCell>{t('drawer.competitions')}</TableCell>
                  <TableCell>{t('drawer.distances')}</TableCell>
                  <TableCell align="right">{t('checkins.ser')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {summaryRows.map(row => (
                  <TableRow key={row.participantId}>
                    <TableCell>{row.participantName}</TableCell>
                    <TableCell>{row.competitionLabel}</TableCell>
                    <TableCell>{row.distanceLabel}</TableCell>
                    <TableCell align="right">{row.ser}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>

      <Box>
        <Typography variant="subtitle1" gutterBottom>
          {t('userCheckinWizard.summaryPriceTitle')}
        </Typography>
        <List dense>
          {Object.entries(priceBreakdown.checkinsByPrice).map(([price, count]) => (
            <ListItem key={price}>
              <ListItemText
                primary={t('checkins.checkinsCount', { count })}
                secondary={t('base.currencyValue', { count: Number(price) })}
              />
            </ListItem>
          ))}
          <ListItem>
            <ListItemIcon>
              <PaymentsIcon />
            </ListItemIcon>
            <ListItemText
              primary={t('checkins.total')}
              secondary={t('base.currencyValue', { count: priceBreakdown.totalPrice })}
            />
          </ListItem>
        </List>
      </Box>
    </Box>
  );
}
